(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  }

  ready(function () {
    var root = document.querySelector('[data-feature="visualiser-v3-mobile"] .pdpv3m-root');
    if (!root || root.dataset.mobileVisualiserReady === 'true') return;
    root.dataset.mobileVisualiserReady = 'true';

    var els = {
      stage: root.querySelector('.pdpv3m-stage'),
      sceneImage: root.querySelector('.pdpv3m-scene-image'),
      artImage: root.querySelector('.pdpv3m-art-image'),
      agedOverlay: root.querySelector('.pdpv3m-aged-overlay'),
      meta: root.querySelector('.pdpv3m-meta'),
      arButton: root.querySelector('#ar-lozenge-mobile'),
      compareGhost: root.querySelector('.pdpv3m-compare-ghost'),
      measureLineW: root.querySelector('.pdpv3m-measure-line--width'),
      measureLineH: root.querySelector('.pdpv3m-measure-line--height'),
      measureLabelW: root.querySelector('.pdpv3m-measure-label--width'),
      measureLabelH: root.querySelector('.pdpv3m-measure-label--height')
    };

    var PRODUCT_IMAGES = {
      landscape: root.dataset.imageLandscape || '',
      portrait: root.dataset.imagePortrait || '',
      square: root.dataset.imageSquare || '',
      fallback: root.dataset.imageFallback || ''
    };
    var SCALE_BACKGROUND_IMAGE = root.dataset.scaleImage || '';
    var FIXED_FRAME_THICKNESS_PX = 4;
    var SOFA_SCALE_FACTOR = 0.56;
    var SOFA_LANDSCAPE_BOOST = 1.22;
    var SOFA_PORTRAIT_MAX_HEIGHT_CM = 150;
    var SOFA_CENTER_Y_OFFSET_PX = 58;
    var SOFA_TOP_BOUND_OFFSET_PX = 95;
    var SOFA_BOTTOM_BOUND_OFFSET_PX = 20;
    var EXACT_SCALE_REFERENCE_SOURCE_SIZE = 1024;
    var EXACT_SCALE_LEFT_BOUNDARY_PX = 130;
    var EXACT_SCALE_REFERENCE_TOP_PX = 100;
    var EXACT_SCALE_REFERENCE_BOTTOM_PX = 727;
    var EXACT_SCALE_REFERENCE_HEIGHT_CM = 200;
    var EXACT_SCENE_SOURCE_SIZE = 919;
    var EXACT_SCENE_TOP_PX = 30;
    var EXACT_SCENE_BOTTOM_INSET_PX = 200;
    var EXACT_SCENE_HEIGHT_PX = 696;
    var EXACT_SCENE_CENTER_PX = EXACT_SCENE_TOP_PX + (EXACT_SCENE_HEIGHT_PX / 2);
    var A_SERIES_SIZES_CM = {
      a0: { widthCm: 84.1, heightCm: 118.9 },
      a1: { widthCm: 59.4, heightCm: 84.1 },
      a2: { widthCm: 42.0, heightCm: 59.4 },
      a3: { widthCm: 29.7, heightCm: 42.0 },
      a4: { widthCm: 21.0, heightCm: 29.7 },
      a5: { widthCm: 14.8, heightCm: 21.0 },
      a6: { widthCm: 10.5, heightCm: 14.8 }
    };
    var FRAME_COLOR_MAP = {
      white: '#f6f2ea',
      black: '#141414',
      oak: '#d5b48a',
      'dark brown': '#6d4320',
      'antique gold': '#b89f63',
      'dark grey': '#4d4d4d',
      'dark gray': '#4d4d4d',
      'antique silver': '#6c6f73'
    };
    var SCENE_IMAGE_BOUNDS = {
      sofa: {
        sourceSize: 1024,
        top: 10,
        bottom: 479,
        left: 110,
        right: 110,
        centerX: 512,
        centerY: 277.5
      },
      gallery: {
        sourceSize: 1024,
        top: 150,
        bottom: 340,
        left: 320,
        right: 312,
        centerX: 520,
        centerY: 388
      },
      charcoal: {
        sourceSize: 1024,
        top: 90,
        bottom: 430,
        left: 220,
        right: 220,
        centerX: 512,
        centerY: 342
      }
    };

    var SCENES = {
      sofa: {
        type: root.dataset.sceneSofaImage ? 'image' : 'css',
        image: root.dataset.sceneSofaImage || ''
      },
      gallery: {
        type: root.dataset.sceneGalleryImage ? 'image' : 'css',
        image: root.dataset.sceneGalleryImage || ''
      },
      charcoal: {
        type: root.dataset.sceneCharcoalImage ? 'image' : 'css',
        image: root.dataset.sceneCharcoalImage || ''
      }
    };

    var state = {
      scene: 'sofa',
      view: 'styled',
      sizeText: '',
      finishText: '',
      toneText: '',
      frameText: '',
      orientationText: '',
      orientation: 'portrait'
    };

    function debounce(fn, wait) {
      var timeoutId;
      return function () {
        var args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
          fn.apply(null, args);
        }, wait);
      };
    }

    function scheduleOptionRerender() {
      [0, 80, 180, 320].forEach(function (delay) {
        window.setTimeout(render, delay);
      });
    }

    function clamp(num, min, max) {
      return Math.min(Math.max(num, min), max);
    }

    function lerp(min, max, t) {
      return min + (max - min) * t;
    }

    function normaliseRange(value, min, max) {
      if (!Number.isFinite(value)) return 0;
      if (max <= min) return 0;
      return clamp((value - min) / (max - min), 0, 1);
    }

    function getCheckedInput(selector) {
      return document.querySelector(selector + ' input[type="radio"]:checked');
    }

    function getTextFromInput(input) {
      if (!input) return '';
      var label = document.querySelector('label[for="' + input.id + '"]');
      return (label ? label.textContent : input.value || '').trim();
    }

    function getSelectionDetails(input) {
      if (!input) {
        return { label: '', value: '' };
      }
      var label = document.querySelector('label[for="' + input.id + '"]');
      return {
        label: (label ? label.textContent : '').trim(),
        value: (input.value || '').trim()
      };
    }

    function getContainerSelectionDetails(containerSelector, inputName) {
      var field = document.querySelector(containerSelector);
      if (!field) return { label: '', value: '' };

      var inputSelector = inputName
        ? 'input[name="' + inputName.replace(/"/g, '\\"') + '"]'
        : 'input[type="radio"]';

      var checkedInput =
        field.querySelector(inputSelector + ':checked') ||
        document.querySelector(inputSelector + ':checked') ||
        field.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        return getSelectionDetails(checkedInput);
      }

      var selectedWrapper = field.querySelector(
        '.spb-productoptionswatchwrapper.selected,' +
        '.spb-productoptionswatchwrapper[aria-checked="true"],' +
        'label.selected,' +
        '[aria-checked="true"],' +
        '.is-selected,' +
        '.selected'
      );
      if (!selectedWrapper) {
        return { label: '', value: '' };
      }

      var wrapperInput = selectedWrapper.querySelector(inputSelector) || selectedWrapper.querySelector('input[type="radio"]');
      if (wrapperInput) {
        return getSelectionDetails(wrapperInput);
      }

      var labelText = (selectedWrapper.textContent || '').trim();
      return { label: labelText, value: labelText };
    }

    function getFirstSelectionDetails(candidates) {
      for (var i = 0; i < candidates.length; i += 1) {
        var candidate = candidates[i];
        if (candidate && (candidate.value || candidate.label)) {
          return candidate;
        }
      }
      return { label: '', value: '' };
    }

    function getSelectedSizeText() {
      return getTextFromInput(getCheckedInput('fieldset[name="Size"]'));
    }

    function getSelectedFinishText() {
      var fieldset = document.querySelector('fieldset[name="Finish"]');
      if (!fieldset) return '';
      var selected = fieldset.querySelector('input[type="radio"]:checked');
      return selected ? (selected.value || '').trim() : '';
    }

    function getSelectedToneText() {
      var selection = getFirstSelectionDetails([
        getContainerSelectionDetails('div.option_colour_tone', 'properties[Colour tone]'),
        getContainerSelectionDetails('.option_colour_tone', 'properties[Colour tone]')
      ]);
      return [selection.value, selection.label].filter(Boolean).join(' ').trim();
    }

    function getSelectedFrameText() {
      var selection = getFirstSelectionDetails([
        getContainerSelectionDetails('div.option_frame_colour_new', 'properties[Frame colour]'),
        getContainerSelectionDetails('.option_frame_colour_new', 'properties[Frame colour]'),
        getContainerSelectionDetails('.option_frame_colour', 'properties[Frame colour]'),
        getContainerSelectionDetails('.option_frame_colour_canvas', 'properties[Frame colour]')
      ]);
      return [selection.value, selection.label].filter(Boolean).join(' ').trim();
    }

    function getSelectedOrientationText() {
      return getTextFromInput(getCheckedInput('fieldset[name="Portrait or landscape?"]'));
    }

    function getDisplayUnitFromLabel(text) {
      var raw = (text || '').toLowerCase();
      if (/\bin\b/.test(raw) || /["”]/.test(raw)) return 'in';
      return 'cm';
    }

    function parseSizeTextToCm(text) {
      var raw = (text || '').trim();
      if (!raw) return null;

      var compact = raw.toLowerCase().replace(/\s+/g, '');
      var aSeriesMatch = compact.match(/\ba([0-6])\b/);
      if (aSeriesMatch) {
        var aKey = 'a' + aSeriesMatch[1];
        if (A_SERIES_SIZES_CM[aKey]) {
          return {
            widthCm: A_SERIES_SIZES_CM[aKey].widthCm,
            heightCm: A_SERIES_SIZES_CM[aKey].heightCm,
            unit: 'mm'
          };
        }
      }

      var match = compact.match(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)(mm|cm|in)?/);
      if (!match) return null;

      var width = parseFloat(match[1]);
      var height = parseFloat(match[2]);
      var unit = match[3] || getDisplayUnitFromLabel(raw);

      if (unit === 'mm') {
        width /= 10;
        height /= 10;
      } else if (unit === 'in') {
        width *= 2.54;
        height *= 2.54;
      }

      return {
        widthCm: width,
        heightCm: height,
        unit: unit === 'mm' ? 'cm' : unit
      };
    }

    function formatSizeTextForMeta(rawText) {
      var raw = (rawText || '').trim();
      if (!raw) return '-';

      var compact = raw.toLowerCase().replace(/\s+/g, '');
      var aSeriesMatch = compact.match(/\ba([0-6])\b/);
      if (aSeriesMatch) {
        var aKey = 'a' + aSeriesMatch[1];
        var dims = A_SERIES_SIZES_CM[aKey];
        if (dims) {
          return aKey.toUpperCase() + ' (' + Math.round(dims.widthCm * 10) + 'x' + Math.round(dims.heightCm * 10) + 'mm)';
        }
      }

      return raw.replace(/\s*x\s*/gi, 'x').replace(/\s+/g, '');
    }

    function getRawSizeDimsForMeta(rawText) {
      var raw = (rawText || '').trim();
      if (!raw) return null;

      var compact = raw.toLowerCase().replace(/\s+/g, '');
      var aSeriesMatch = compact.match(/\ba([0-6])\b/);
      if (aSeriesMatch) {
        var aKey = 'a' + aSeriesMatch[1];
        if (A_SERIES_SIZES_CM[aKey]) {
          return {
            widthCm: A_SERIES_SIZES_CM[aKey].widthCm,
            heightCm: A_SERIES_SIZES_CM[aKey].heightCm,
            unit: 'mm'
          };
        }
      }

      var match = compact.match(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)(mm|cm|in)?/);
      if (!match) return null;

      var width = parseFloat(match[1]);
      var height = parseFloat(match[2]);
      var unit = match[3] || getDisplayUnitFromLabel(raw);

      if (unit === 'mm') {
        width /= 10;
        height /= 10;
      } else if (unit === 'in') {
        width *= 2.54;
        height *= 2.54;
      }

      return {
        widthCm: width,
        heightCm: height,
        unit: unit
      };
    }

    function formatFramedSizeForMeta(rawText) {
      var rawDims = getRawSizeDimsForMeta(rawText);
      if (!rawDims) return '';
      var frameEachSideCm = rawDims.unit === 'in' ? 2.54 : 2;
      return formatDims(
        rawDims.widthCm + (frameEachSideCm * 2),
        rawDims.heightCm + (frameEachSideCm * 2),
        rawDims.unit
      );
    }

    function normaliseToneKey(toneText) {
      var key = (toneText || '').toLowerCase();
      if (document.querySelector('input[name="properties[Colour tone]"][value*="Aged"]:checked')) return 'aged';
      return key.indexOf('aged') !== -1 ? 'aged' : 'original';
    }

    function resolveFrameColor(frameText) {
      var key = (frameText || '').toLowerCase();
      if (!key) return '#181818';

      for (var mapKey in FRAME_COLOR_MAP) {
        if (Object.prototype.hasOwnProperty.call(FRAME_COLOR_MAP, mapKey) && key.indexOf(mapKey) !== -1) {
          return FRAME_COLOR_MAP[mapKey];
        }
      }

      return '#181818';
    }

    function inferOrientation(rawDimensions) {
      var fallbackSrc = PRODUCT_IMAGES.fallback || '';
      var dedicatedOrientations = [];

      ['landscape', 'portrait', 'square'].forEach(function (key) {
        var src = PRODUCT_IMAGES[key] || '';
        if (src && src !== fallbackSrc) {
          dedicatedOrientations.push(key);
        }
      });

      if (dedicatedOrientations.length === 1) {
        return dedicatedOrientations[0];
      }

      if (rawDimensions && Math.abs(rawDimensions.widthCm - rawDimensions.heightCm) < 0.01) {
        return 'square';
      }
      if (rawDimensions && rawDimensions.widthCm > rawDimensions.heightCm) return 'landscape';
      if (rawDimensions && rawDimensions.heightCm > rawDimensions.widthCm) return 'portrait';
      if (els.artImage && els.artImage.naturalWidth && els.artImage.naturalHeight) {
        var ratio = els.artImage.naturalWidth / Math.max(els.artImage.naturalHeight, 1);
        if (ratio > 1.02) return 'landscape';
        if (ratio < 0.98) return 'portrait';
        return 'square';
      }
      return 'portrait';
    }

    function orientDims(dimensions, orientation) {
      if (!dimensions) return null;
      var width = dimensions.widthCm;
      var height = dimensions.heightCm;

      if (orientation === 'landscape' && height > width) {
        var widthSwap = width;
        width = height;
        height = widthSwap;
      }
      if (orientation === 'portrait' && width > height) {
        var heightSwap = width;
        width = height;
        height = heightSwap;
      }
      if (orientation === 'square') {
        var side = Math.min(width, height);
        width = side;
        height = side;
      }

      return { widthCm: width, heightCm: height, unit: dimensions.unit };
    }

    function formatValueForDisplay(value, unit) {
      if (!Number.isFinite(value)) return '-';
      if (unit === 'mm') {
        return String(Math.round(value * 10));
      }
      if (unit === 'in') {
        var inches = value / 2.54;
        var roundedInches = Math.round(inches * 10) / 10;
        return Number.isInteger(roundedInches) ? String(roundedInches) : roundedInches.toFixed(1);
      }
      var roundedCm = Math.round(value * 10) / 10;
      return Number.isInteger(roundedCm) ? String(roundedCm) : roundedCm.toFixed(1);
    }

    function formatDims(widthCm, heightCm, unit) {
      return formatValueForDisplay(widthCm, unit) + 'x' + formatValueForDisplay(heightCm, unit) + unit;
    }

    function getFrameThicknessCm(unit) {
      if (unit === 'mm') return 2;
      return unit === 'in' ? 2.54 : 2;
    }

    function getOuterDims(dimensions, finishKey) {
      if (!dimensions) return null;
      if (finishKey !== 'framed') return dimensions;

      var frameEachSideCm = dimensions.unit === 'in' ? 2.54 : 2;
      return {
        widthCm: dimensions.widthCm + (frameEachSideCm * 2),
        heightCm: dimensions.heightCm + (frameEachSideCm * 2),
        unit: dimensions.unit
      };
    }

    function getSourceImageAspectRatio() {
      if (els.artImage && els.artImage.naturalWidth && els.artImage.naturalHeight) {
        return els.artImage.naturalWidth / els.artImage.naturalHeight;
      }
      if (state.orientation === 'landscape') return 4 / 3;
      if (state.orientation === 'square') return 1;
      return 0.75;
    }

    function getProxyDimensionsCm(selectedDimensions, imageRatio) {
      if (!selectedDimensions || !imageRatio) return null;

      if (selectedDimensions.heightCm >= selectedDimensions.widthCm) {
        return {
          widthCm: selectedDimensions.heightCm * imageRatio,
          heightCm: selectedDimensions.heightCm
        };
      }

      return {
        widthCm: selectedDimensions.widthCm,
        heightCm: selectedDimensions.widthCm / imageRatio
      };
    }

    function getOrientationFromRenderedRatio(imageRatio, fallbackDimensions) {
      if (imageRatio) {
        if (Math.abs(imageRatio - 1) < 0.02) return 'square';
        return imageRatio > 1 ? 'landscape' : 'portrait';
      }
      return inferOrientation(fallbackDimensions);
    }

    function getRenderBox(selectedDimensions, stageWidth, stageHeight, view) {
      var widthNorm = normaliseRange(selectedDimensions.widthCm, 30, 300);
      var heightNorm = normaliseRange(selectedDimensions.heightCm, 30, 200);

      if (view === 'styled') {
        return {
          width: lerp(stageWidth * 0.18, stageWidth * 0.56, widthNorm),
          height: lerp(stageHeight * 0.28, stageHeight * 0.53, heightNorm)
        };
      }

      return {
        width: lerp(stageWidth * 0.24, stageWidth * 0.92, widthNorm),
        height: lerp(stageHeight * 0.32, stageHeight * 0.88, heightNorm)
      };
    }

    function getArtPixels(proxyDimensions, selectedDimensions, stageWidth, stageHeight, view) {
      var renderBox = getRenderBox(selectedDimensions, stageWidth, stageHeight, view);
      var fit = Math.min(
        renderBox.width / Math.max(proxyDimensions.widthCm, 1),
        renderBox.height / Math.max(proxyDimensions.heightCm, 1)
      );

      return {
        width: Math.max(20, Math.round(proxyDimensions.widthCm * fit)),
        height: Math.max(20, Math.round(proxyDimensions.heightCm * fit))
      };
    }

    function getFrameThicknessPx(proxyDimensions, artPixels, unit) {
      if (!proxyDimensions || !artPixels) return 0;
      return FIXED_FRAME_THICKNESS_PX;
    }

    function getSceneImageBounds(sceneKey, stageWidth, stageHeight) {
      var config = SCENE_IMAGE_BOUNDS[sceneKey];
      if (!config) return null;

      var scale = Math.max(stageWidth / config.sourceSize, stageHeight / config.sourceSize);
      var renderedSize = config.sourceSize * scale;
      var offsetX = (stageWidth - renderedSize) / 2;
      var offsetY = (stageHeight - renderedSize) / 2;

      return {
        scale: scale,
        offsetX: offsetX,
        offsetY: offsetY,
        left: offsetX + (config.left * scale),
        top: offsetY + (config.top * scale),
        width: (config.sourceSize - config.left - config.right) * scale,
        height: (config.sourceSize - config.top - config.bottom) * scale
      };
    }

    function getStyledScenePlacement(sceneKey, proxyDimensions, selectedDimensions, stageWidth, stageHeight) {
      var config = SCENE_IMAGE_BOUNDS[sceneKey];
      var bounds = getSceneImageBounds(sceneKey, stageWidth, stageHeight);
      if (!bounds) return null;
      var scale = bounds.scale;
      var centerX = config.centerX ? (bounds.offsetX + (config.centerX * scale)) : (bounds.left + (bounds.width / 2));
      var centerY = config.centerY ? (bounds.offsetY + (config.centerY * scale)) : (bounds.top + (bounds.height / 2));
      var maxWidthFromCenter = 2 * Math.min(centerX - bounds.left, (bounds.left + bounds.width) - centerX);
      var maxHeightFromCenter = 2 * Math.min(centerY - bounds.top, (bounds.top + bounds.height) - centerY);

      var widthNorm = normaliseRange(selectedDimensions.widthCm, 30, 300);
      var heightNorm = normaliseRange(selectedDimensions.heightCm, 30, 200);
      var minWidthFactor = sceneKey === 'gallery' ? 0.48 : 0.24;
      var minHeightFactor = sceneKey === 'gallery' ? 0.48 : 0.24;
      var maxWidthFactor = sceneKey === 'gallery' ? 1.06 : 0.98;
      var maxHeightFactor = sceneKey === 'gallery' ? 1.04 : 0.98;
      var preferredWidth = lerp(bounds.width * minWidthFactor, bounds.width * maxWidthFactor, widthNorm);
      var preferredHeight = lerp(bounds.height * minHeightFactor, bounds.height * maxHeightFactor, heightNorm);
      var fit = Math.min(
        preferredWidth / Math.max(proxyDimensions.widthCm, 1),
        preferredHeight / Math.max(proxyDimensions.heightCm, 1),
        Math.max(20, maxWidthFromCenter) / Math.max(proxyDimensions.widthCm, 1),
        Math.max(20, maxHeightFromCenter) / Math.max(proxyDimensions.heightCm, 1)
      );
      var artWidth = Math.max(20, Math.round(proxyDimensions.widthCm * fit));
      var artHeight = Math.max(20, Math.round(proxyDimensions.heightCm * fit));

      return {
        width: artWidth,
        height: artHeight,
        left: centerX,
        top: centerY
      };
    }

    function getExactScalePlacement(exactDimensions, proxyDimensions, stageWidth, stageHeight, finishKey) {
      if (!exactDimensions || !proxyDimensions) return null;

      var sceneScale = Math.min(
        stageWidth / EXACT_SCALE_REFERENCE_SOURCE_SIZE,
        stageHeight / EXACT_SCALE_REFERENCE_SOURCE_SIZE
      );
      var pxPerCm = sceneScale * (
        (EXACT_SCALE_REFERENCE_BOTTOM_PX - EXACT_SCALE_REFERENCE_TOP_PX) /
        EXACT_SCALE_REFERENCE_HEIGHT_CM
      );
      var exactBoxWidth = Math.max(20, exactDimensions.widthCm * pxPerCm);
      var exactBoxHeight = Math.max(20, exactDimensions.heightCm * pxPerCm);
      var artFit = Math.min(
        exactBoxWidth / Math.max(proxyDimensions.widthCm, 1),
        exactBoxHeight / Math.max(proxyDimensions.heightCm, 1)
      );
      var artWidth = Math.max(20, Math.round(proxyDimensions.widthCm * artFit));
      var artHeight = Math.max(20, Math.round(proxyDimensions.heightCm * artFit));
      var frameThicknessPx = finishKey === 'framed'
        ? getFrameThicknessPx(exactDimensions, { width: artWidth, height: artHeight }, exactDimensions.unit)
        : 0;
      var shellWidth = artWidth + (frameThicknessPx * 2);
      var shellHeight = artHeight + (frameThicknessPx * 2);
      var leftLimit = EXACT_SCALE_LEFT_BOUNDARY_PX * sceneScale;
      var topLimit = EXACT_SCALE_REFERENCE_TOP_PX * sceneScale;
      var bottomLimit = EXACT_SCALE_REFERENCE_BOTTOM_PX * sceneScale;
      var centerX = leftLimit + ((stageWidth - leftLimit) / 2);
      var centerY = topLimit + ((bottomLimit - topLimit) / 2);
      var artLeft = clamp(centerX, leftLimit + (shellWidth / 2), stageWidth - (shellWidth / 2));
      var artTop = clamp(centerY, topLimit + (shellHeight / 2), bottomLimit - (shellHeight / 2));

      return {
        width: artWidth,
        height: artHeight,
        left: artLeft,
        top: artTop
      };
    }

    function getSofaPlacement(proxyDimensions, stageWidth, stageHeight) {
      if (!proxyDimensions) return null;

      var bounds = getSceneImageBounds('sofa', stageWidth, stageHeight);
      if (!bounds) return null;
      var sofaConfig = SCENE_IMAGE_BOUNDS.sofa;

      var safeWidth = Math.max(20, bounds.width);
      var safeHeight = Math.max(20, bounds.height);
      var centerX = bounds.centerX || (bounds.left + (bounds.width / 2));
      var centerY = sofaConfig && sofaConfig.centerY
        ? (bounds.offsetY + ((sofaConfig.centerY + SOFA_CENTER_Y_OFFSET_PX) * bounds.scale))
        : (bounds.top + (bounds.height / 2));
      var isLandscape = proxyDimensions.widthCm > proxyDimensions.heightCm * 1.05;
      var isPortrait = proxyDimensions.heightCm > proxyDimensions.widthCm * 1.05;
      var artWidth;
      var artHeight;

      if (isPortrait) {
        var cappedPortraitHeightCm = Math.min(proxyDimensions.heightCm, SOFA_PORTRAIT_MAX_HEIGHT_CM);
        var portraitPxPerCm = safeHeight / Math.max(SOFA_PORTRAIT_MAX_HEIGHT_CM, 1);
        artHeight = Math.max(20, Math.round(cappedPortraitHeightCm * portraitPxPerCm));
        artWidth = Math.max(
          20,
          Math.round(artHeight * (proxyDimensions.widthCm / Math.max(proxyDimensions.heightCm, 1)))
        );
      } else {
        var sceneScale = Math.min(stageWidth / EXACT_SCENE_SOURCE_SIZE, stageHeight / EXACT_SCENE_SOURCE_SIZE);
        var pxPerCm = sceneScale * (EXACT_SCENE_HEIGHT_PX / 200);
        artWidth = Math.max(20, Math.round(proxyDimensions.widthCm * pxPerCm * SOFA_SCALE_FACTOR));
        artHeight = Math.max(20, Math.round(proxyDimensions.heightCm * pxPerCm * SOFA_SCALE_FACTOR));

        if (isLandscape) {
          artWidth = Math.max(20, Math.round(artWidth * SOFA_LANDSCAPE_BOOST));
          artHeight = Math.max(20, Math.round(artHeight * SOFA_LANDSCAPE_BOOST));
        }
      }

      if (artWidth > safeWidth || artHeight > safeHeight) {
        var safeFit = Math.min(
          safeWidth / Math.max(artWidth, 1),
          safeHeight / Math.max(artHeight, 1)
        );
        artWidth = Math.max(20, Math.round(artWidth * safeFit));
        artHeight = Math.max(20, Math.round(artHeight * safeFit));
      }

      var topLimit = bounds.top + (SOFA_TOP_BOUND_OFFSET_PX * bounds.scale);
      var bottomLimit = bounds.top + bounds.height - (SOFA_BOTTOM_BOUND_OFFSET_PX * bounds.scale);
      var verticalSafeHeight = Math.max(20, bottomLimit - topLimit);

      if (artHeight > verticalSafeHeight) {
        var verticalFit = verticalSafeHeight / Math.max(artHeight, 1);
        artWidth = Math.max(20, Math.round(artWidth * verticalFit));
        artHeight = Math.max(20, Math.round(artHeight * verticalFit));
      }

      centerY = clamp(
        centerY,
        topLimit + (artHeight / 2),
        bottomLimit - (artHeight / 2)
      );

      return {
        width: artWidth,
        height: artHeight,
        left: centerX,
        top: centerY
      };
    }

    function triggerVendorAr() {
      var target = document.getElementById('ar-button') || document.querySelector('[rel="ar"]');
      if (!target) return false;

      if (target.classList) target.classList.add('ar-button--visually-hidden');

      if (typeof target.click === 'function') {
        target.click();
      } else {
        target.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }));
      }

      return true;
    }

    function jumpToVisualiserSlide() {
      if (typeof window.__pdpv3SelectVisualiserSlide !== 'function') return;
      if (window.__pdpv3SelectVisualiserSlide()) return;
      window.setTimeout(window.__pdpv3SelectVisualiserSlide, 120);
      window.setTimeout(window.__pdpv3SelectVisualiserSlide, 280);
    }

    function readState() {
      state.sizeText = getSelectedSizeText();
      state.finishText = getSelectedFinishText();
      state.toneText = getSelectedToneText();
      state.frameText = getSelectedFrameText();
      state.orientationText = getSelectedOrientationText();

      var orientationRaw = (state.orientationText || '').toLowerCase();
      var rawSizeDims = parseSizeTextToCm(state.sizeText);
      if (orientationRaw.indexOf('landscape') !== -1) state.orientation = 'landscape';
      else if (orientationRaw.indexOf('square') !== -1) state.orientation = 'square';
      else if (orientationRaw.indexOf('portrait') !== -1) state.orientation = 'portrait';
      else state.orientation = inferOrientation(rawSizeDims);
    }

    function renderScene() {
      var scene = SCENES[state.scene];
      if (!scene) return;

      root.dataset.scene = state.scene;
      root.dataset.sceneType = ((state.view === 'scale' && SCALE_BACKGROUND_IMAGE) || (state.view !== 'scale' && scene.type === 'image' && scene.image)) ? 'image' : 'css';

      var activeSceneImage = state.view === 'scale' ? SCALE_BACKGROUND_IMAGE : scene.image;
      var useImageScene = root.dataset.sceneType === 'image' && activeSceneImage;

      if (useImageScene) {
        if (els.sceneImage.getAttribute('src') !== activeSceneImage) {
          els.sceneImage.src = activeSceneImage;
        }
        els.sceneImage.style.display = 'block';
        els.sceneImage.style.opacity = '1';
        els.sceneImage.style.visibility = 'visible';
        els.stage.style.backgroundImage = 'url("' + activeSceneImage.replace(/"/g, '\\"') + '")';
        els.stage.style.backgroundSize = 'cover';
        els.stage.style.backgroundPosition = 'center center';
        els.stage.style.backgroundRepeat = 'no-repeat';
      } else {
        els.sceneImage.removeAttribute('src');
        els.sceneImage.style.removeProperty('display');
        els.sceneImage.style.removeProperty('opacity');
        els.sceneImage.style.removeProperty('visibility');
        els.stage.style.removeProperty('background-image');
        els.stage.style.removeProperty('background-size');
        els.stage.style.removeProperty('background-position');
        els.stage.style.removeProperty('background-repeat');
      }
    }

    function renderMeasurements(artLeft, artTop, artWidth, artHeight, dims, stageWidth) {
      var topY = Math.max(12, artTop - 16);
      els.measureLineW.style.left = artLeft + 'px';
      els.measureLineW.style.top = topY + 'px';
      els.measureLineW.style.width = artWidth + 'px';

      els.measureLabelW.textContent = formatValueForDisplay(dims.widthCm, dims.unit) + ' ' + dims.unit;
      els.measureLabelW.style.left = (artLeft + artWidth / 2) + 'px';
      els.measureLabelW.style.top = Math.max(0, topY - 18) + 'px';
      els.measureLabelW.style.transform = 'translate(-50%, 0)';

      var leftX = Math.max(10, artLeft - 14);
      els.measureLineH.style.left = leftX + 'px';
      els.measureLineH.style.top = artTop + 'px';
      els.measureLineH.style.height = artHeight + 'px';

      els.measureLabelH.textContent = formatValueForDisplay(dims.heightCm, dims.unit) + ' ' + dims.unit;
      els.measureLabelH.style.left = Math.max(4, leftX - 54) + 'px';
      els.measureLabelH.style.top = (artTop + artHeight / 2 - 12) + 'px';
      els.measureLabelH.style.transform = 'translate(0, 0)';

      if (artWidth < 100) {
        els.measureLabelW.style.left = Math.min(stageWidth - 56, artLeft + artWidth + 10) + 'px';
        els.measureLabelW.style.top = topY + 'px';
        els.measureLabelW.style.transform = 'translate(0, 0)';
      }
    }

    function resetCompareGhost() {
      if (!els.compareGhost) return;
      els.compareGhost.dataset.hasGhost = 'false';
      els.compareGhost.style.width = '0px';
      els.compareGhost.style.height = '0px';
    }

    function getArtImageSrc() {
      if (state.orientation === 'landscape') {
        return PRODUCT_IMAGES.landscape || PRODUCT_IMAGES.fallback || PRODUCT_IMAGES.portrait || PRODUCT_IMAGES.square || '';
      }
      if (state.orientation === 'square') {
        return PRODUCT_IMAGES.square || PRODUCT_IMAGES.fallback || PRODUCT_IMAGES.portrait || PRODUCT_IMAGES.landscape || '';
      }
      return PRODUCT_IMAGES.portrait || PRODUCT_IMAGES.fallback || PRODUCT_IMAGES.landscape || PRODUCT_IMAGES.square || '';
    }

    function getOverlayOrientation(dimensions) {
      if (els.artImage && els.artImage.naturalWidth && els.artImage.naturalHeight) {
        var ratio = els.artImage.naturalWidth / Math.max(els.artImage.naturalHeight, 1);
        if (ratio > 1.02) return 'landscape';
        if (ratio < 0.98) return 'portrait';
        return 'square';
      }

      if (!dimensions) return state.orientation;
      if (Math.abs(dimensions.widthCm - dimensions.heightCm) < 0.01) return 'square';
      return dimensions.widthCm > dimensions.heightCm ? 'landscape' : 'portrait';
    }

    function render() {
      readState();

      var dims = parseSizeTextToCm(state.sizeText);
      if (!dims) return;
      var physicalDims = state.view === 'scale'
        ? orientDims(dims, inferOrientation(dims))
        : dims;
      if (!physicalDims) return;

      var finishRaw = (state.finishText || '').toLowerCase();
      var finishKey = 'unframed';
      if (finishRaw.indexOf('fram') !== -1) finishKey = 'framed';
      else if (finishRaw.indexOf('canvas') !== -1) finishKey = 'canvas';

      root.dataset.view = state.view;
      root.dataset.finish = finishKey;
      root.dataset.tone = normaliseToneKey(state.toneText);
      root.dataset.compare = 'false';
      var activeSceneKey = state.view === 'scale' ? 'scale' : state.scene;
      root.querySelectorAll('[data-mobile-scene-btn]').forEach(function (item) {
        item.classList.toggle('is-active', item.dataset.mobileSceneBtn === activeSceneKey);
      });
      renderScene();

      var artSrc = getArtImageSrc();
      if (artSrc) {
        if (els.artImage.getAttribute('src') !== artSrc) {
          els.artImage.src = artSrc;
        }
        els.artImage.style.opacity = '1';
        els.artImage.style.visibility = 'visible';
        els.artImage.style.display = 'block';
      }

      var overlayOrientation = getOverlayOrientation(dims);
      var overlaySrc = overlayOrientation === 'landscape'
        ? root.dataset.overlayLandscape
        : overlayOrientation === 'square'
          ? root.dataset.overlaySquare
          : root.dataset.overlayPortrait;

      if (overlaySrc && els.agedOverlay.getAttribute('src') !== overlaySrc) {
        els.agedOverlay.src = overlaySrc;
      }

      var outerDims = getOuterDims(dims, finishKey);
      var metaText = formatSizeTextForMeta(state.sizeText);
      if (finishKey === 'framed' && outerDims) {
        metaText += ' (' + (formatFramedSizeForMeta(state.sizeText) || formatDims(outerDims.widthCm, outerDims.heightCm, outerDims.unit)) + ' framed)';
      }
      els.meta.textContent = metaText;

      var stageRect = els.stage.getBoundingClientRect();
      var stageWidth = stageRect.width || root.clientWidth || 320;
      var stageHeight = stageRect.height || root.clientHeight || 320;
      var imageRatio = getSourceImageAspectRatio() || 0.75;
      var proxy = getProxyDimensionsCm(physicalDims, imageRatio);
      if (!proxy) return;
      var measurementDims = physicalDims;
      if (state.view === 'scale') {
        measurementDims = orientDims(dims, getOrientationFromRenderedRatio(imageRatio, dims)) || physicalDims;
      }

      var artPlacement = state.view === 'scale'
        ? getExactScalePlacement(measurementDims, proxy, stageWidth, stageHeight, finishKey)
        : state.scene === 'sofa'
          ? getSofaPlacement(proxy, stageWidth, stageHeight)
          : getStyledScenePlacement(state.scene, proxy, dims, stageWidth, stageHeight);
      var artPixels = artPlacement || getArtPixels(proxy, physicalDims, stageWidth, stageHeight, state.view);
      var artWidth = artPixels.width;
      var artHeight = artPixels.height;

      var artLeft = artPlacement ? artPlacement.left : stageWidth * 0.50;
      var artTop = artPlacement
        ? artPlacement.top
        : clamp(stageHeight * 0.30, artHeight / 2 + 10, stageHeight * 0.40);

      root.style.setProperty('--pdpv3m-art-left', artLeft + 'px');
      root.style.setProperty('--pdpv3m-art-top', artTop + 'px');
      root.style.setProperty('--pdpv3m-art-width', artWidth + 'px');
      root.style.setProperty('--pdpv3m-art-height', artHeight + 'px');
      root.style.setProperty('--pdpv3m-frame-color', resolveFrameColor(state.frameText));
      root.style.setProperty(
        '--pdpv3m-frame-thickness',
        finishKey === 'framed' ? (getFrameThicknessPx(proxy, artPixels, dims.unit) + 'px') : '0px'
      );

      renderMeasurements(
        artLeft - artWidth / 2,
        artTop - artHeight / 2,
        artWidth,
        artHeight,
        measurementDims,
        stageWidth
      );
      resetCompareGhost();
    }

    root.querySelectorAll('[data-mobile-scene-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.dataset.mobileSceneBtn;
        if (next === 'scale') {
          state.view = 'scale';
        } else {
          state.view = 'styled';
          state.scene = next;
        }
        root.querySelectorAll('[data-mobile-scene-btn]').forEach(function (item) {
          item.classList.toggle('is-active', item === btn);
        });
        render();
      });
    });

    if (els.arButton) {
      els.arButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (triggerVendorAr()) return;
        window.setTimeout(triggerVendorAr, 250);
      });
    }

    var rerender = debounce(render, 80);

    document.querySelectorAll(
      'fieldset[name="Size"] input, fieldset[name="Finish"] input, fieldset[name="Portrait or landscape?"] input'
    ).forEach(function (el) {
      el.addEventListener('change', function () {
        jumpToVisualiserSlide();
        rerender();
      });
      el.addEventListener('click', function () {
        jumpToVisualiserSlide();
        window.setTimeout(rerender, 80);
      });
    });

    document.querySelectorAll('.variant-input--pseudo, .variant-input--pseudo .pseudo-button, label.variant__button-label').forEach(function (el) {
      el.addEventListener('click', function () {
        jumpToVisualiserSlide();
      });
    });

    document.querySelectorAll('div.option_colour_tone input, div.option_frame_colour_new input').forEach(function (el) {
      el.addEventListener('change', function () {
        jumpToVisualiserSlide();
        rerender();
        scheduleOptionRerender();
      });
      el.addEventListener('click', function () {
        jumpToVisualiserSlide();
        scheduleOptionRerender();
      });
    });

    document.querySelectorAll('div.option_colour_tone, div.option_frame_colour_new').forEach(function (el) {
      el.addEventListener('click', function () {
        jumpToVisualiserSlide();
        scheduleOptionRerender();
      });
    });

    if (typeof MutationObserver !== 'undefined') {
      var optionObserverTargets = document.querySelectorAll(
        'div.option_colour_tone, .option_colour_tone, div.option_frame_colour_new, .option_frame_colour_new, .option_frame_colour, .option_frame_colour_canvas'
      );
      optionObserverTargets.forEach(function (target) {
        var observer = new MutationObserver(function () {
          scheduleOptionRerender();
        });
        observer.observe(target, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['class', 'checked', 'aria-checked']
        });
      });
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (
        target.matches('input[name="properties[Colour tone]"]') ||
        target.matches('input[name="properties[Frame colour]"]')
      ) {
        jumpToVisualiserSlide();
        scheduleOptionRerender();
      }
    });

    window.addEventListener('resize', rerender);
    if (els.artImage) els.artImage.addEventListener('load', rerender);
    if (els.sceneImage) els.sceneImage.addEventListener('load', rerender);

    render();
  });
})();
